export default {
  mounted() {},
}
